import { SessionState } from "./models";

export interface SessionsUtilsStateInterface {
  session_state: {
    [key: string]: SessionState;
  };
}

function state(): SessionsUtilsStateInterface {
  return {
    session_state: {},
  };
}

export default state;
